import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import { useShowMasterPolicyFlow } from "../../../userFeatures/hooks/useShowMasterPolicyFlow";
import { Benefit } from "../data";
import { BenefitsSection, BenefitsTab } from "../data/sections";
import { selectorCatalogBenefits } from "../selectors/selectorCatalogBenefits";

/**
 * Resolves the member state the catalog is filtered by, and applies it.
 *
 * The catalog itself is static — only the gates around it need fetching.
 */
export const useBenefitsCatalog = (params: {
  /** Undefined while the route resolves an unknown section. */
  section?: BenefitsSection;
  tab?: BenefitsTab;
}): { benefits: Benefit[]; isLoading: boolean } => {
  const queryFeatureFlags = useQueryFeatureFlags();
  const showMasterPolicy = useShowMasterPolicyFlow();

  return {
    isLoading: queryFeatureFlags.isLoading,
    benefits: params.section
      ? selectorCatalogBenefits({
          section: params.section,
          tab: params.tab,
          featureFlags: queryFeatureFlags.data,
          showMasterPolicy
        })
      : []
  };
};
